import {IconProps} from '../../types/IconProps'

const StorageUsedIcon = ({height, width}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '20'}
      height={height || '20'}
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_6809_7121)'>
        <path
          d='M6.24997 10C6.24997 8.76387 6.61653 7.5555 7.30329 6.52769C7.99005 5.49988 8.96616 4.6988 10.1082 4.22576C11.2502 3.75271 12.5069 3.62894 13.7193 3.87009C14.9317 4.11125 16.0453 4.70651 16.9194 5.58059C17.7935 6.45466 18.3887 7.56831 18.6299 8.78069C18.871 9.99307 18.7473 11.2497 18.2742 12.3918C17.8012 13.5338 17.0001 14.5099 15.9723 15.1967C14.9445 15.8834 13.7361 16.25 12.5 16.25H5.62497C5.00463 16.2492 4.39154 16.1166 3.82639 15.8608C3.26124 15.605 2.75694 15.2319 2.34697 14.7664C1.937 14.3008 1.63072 13.7534 1.44846 13.1604C1.2662 12.5674 1.21213 11.9425 1.28983 11.327C1.36753 10.7116 1.57522 10.1197 1.89913 9.5906C2.22305 9.06154 2.65577 8.60741 3.16859 8.25835C3.6814 7.90928 4.26259 7.67326 4.87358 7.56596C5.48458 7.45865 6.1114 7.48251 6.71247 7.63594'
          stroke='#666666'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6809_7121'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default StorageUsedIcon
